import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum.ts";
import { AuthErrorCodeEnum } from "jadro-pico/enums/pico-com/AuthErrorCodeEnum.ts";
import { defineErrorResources } from "./defineErrorResources.ts";

export const PicoComErrorResources = defineErrorResources({
  [LanguageEnum.CS]: {
    [AuthErrorCodeEnum.INVALID_CREDENTIALS]: "Neplatné přihlašovací údaje",
    [AuthErrorCodeEnum.TOKEN_EXPIRED]: "Platnost relace vypršela",
    [AuthErrorCodeEnum.SESSION_ENDED]: "Relace byla ukončena",
  },
  [LanguageEnum.EN]: {
    [AuthErrorCodeEnum.INVALID_CREDENTIALS]: "Invalid credentials",
    [AuthErrorCodeEnum.TOKEN_EXPIRED]: "Session expired",
    [AuthErrorCodeEnum.SESSION_ENDED]: "Session ended",
  },
});
